import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Table, Popover } from 'antd';
import { InfoCircleIcon } from '../../../../common/icons';

import './ConnectionRequestTable.css';
import { DeleteOutlined } from "@ant-design/icons";
import AirModalTitlebar from "../../../../common/components/AirModalTitlebar";
import AirButton from "../../../../common/components/AirButton";

@inject('commonStore', 'translationsStore', 'connectionRequestsStore', 'subscriptionsStore')
@observer
class ConnectionRequestTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleDeleteModal: false,
      visibleMessageModalError: false,
      visibleMessageModalSuccess: false
    };
  }

  buildDataSourceWithKeys = (collection) => collection.map((item, index) => ({ ...item, key: index }));

  installerColumn = (text, record) => {
    if (record.vehicle && record.vehicle.installer) {
      const installerAddress = record.vehicle.installer.addresses ? (record.vehicle.installer.addresses.find((el) => el.type === 'operational_office') || {}).node : undefined;
      return (
        <div>
          {installerAddress && (
            <Popover
              placement={'left'}
              content={
                <div className={'PopOverInstallerInfo'}>
                  <div className={'PopOverInstallerTitle'}>{record.vehicle.installer.company_name}</div>
                  {`${installerAddress.street} ${installerAddress.building_number}`}
                  <br />
                  {`${installerAddress.postcode} ${installerAddress.city} (${installerAddress.province})`}
                  <br />
                  {`Tel.: ${record.vehicle.installer.phone}`}
                </div>
              }
            >
              <InfoCircleIcon style={{ width: '20px', height: '20px', color: 'var(--primary-color)', backgroundColor: 'white', borderRadius: 20 }} />
            </Popover>
          )}
          <span>{record.vehicle.installer.company_name}</span>
        </div>
      );
    } else {
      return '-';
    }
  };

  onDeleteClick = (vehicleUuid) => {
    this.setState({uuidVehicleToDelete: vehicleUuid, visibleDeleteModal:true});
  };

  deleteRequest = ()=> {
    const { connectionRequestsStore, subscriptionsStore } = this.props;

    connectionRequestsStore.deleteConnectionRequest(this.state.uuidVehicleToDelete)
      .then(() => {
        this.setState({visibleMessageModalSuccess:true});
        subscriptionsStore.load();
      })
      .catch(() => {
        this.setState({visibleMessageModalError:true});
      })
      .finally(()=> this.setState({visibleDeleteModal:false}));
  }

  render() {
    const { connectionRequests, translationsStore } = this.props;

    const dataSource = this.buildDataSourceWithKeys(connectionRequests);

    const columns = [
      {
        key: 'plate',
        dataIndex: 'plate',
        className: 'ColumnCentered',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.plate'),
        render: (text, record) => record.vehicle.license_plate,
      },
      {
        key: 'make',
        dataIndex: 'make',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.make'),
        render: (text, record) => record.vehicle.brand.name,
      },
      {
        key: 'model',
        dataIndex: 'model',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.model'),
        render: (text, record) => record.vehicle.model.name,
      },
      {
        key: 'serviceType',
        dataIndex: 'serviceType',
        className: 'ColumnCentered',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.serviceType'),
        render: (text, record) => translationsStore.translate(`connectionRequests.vehicleTable.serviceTypes.${record.portability_reference_contract_uuid ? 'portability' : 'newSubscription'}`)
      },
      {
        key: 'product',
        dataIndex: 'product',
        className: 'ColumnCentered',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.product'),
        render: (text, record) => Array.isArray(record.product)? record.product.map(el=>el.name).join(', ') : record.product.name
      },
      {
        key: 'subscriptionType',
        dataIndex: 'subscriptionType',
        className: 'ColumnCentered',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.subscriptionType'),
        render: (text, record) => translationsStore.translate(`connectionRequests.subscriptionType.${record.subscriptionType.name}`),
      },
      {
        key: 'creationDate',
        dataIndex: 'creationDate',
        className: 'ColumnCentered',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.creationDate'),
        render: (text, record) => moment(record.createdAt).format('DD/MM/YYYY'),
      },
      {
        key: 'installer',
        dataIndex: 'installer',
        className: 'ColumnWithIcon',
        title: translationsStore.translate('connectionRequests.vehicleTable.headerLabels.installer'),
        render: this.installerColumn,
      },
      {
        key: 'delete',
        dataIndex: 'delete',
        className: 'ColumnCentered',
        title: '',
        render: (text, record) => <DeleteOutlined className={'IconColor DeleteIcon'} onClick={() => record.vehicle && this.onDeleteClick(record.vehicle.uuid)} />
      }
    ];

    return (
      <div className="ConnectionsTable">
        <Table columns={columns} dataSource={dataSource} rowClassName="ClientRow" pagination={false}/>
        <AirModalTitlebar
          visible={this.state.visibleDeleteModal}
          cancelButton={<AirButton size="large" label={'No'} style={{ width: 240 }} />}
          okButton={<AirButton size="large" light label={translationsStore.translate('connectionRequests.vehicleTable.deleteModal.okButtonText')} style={{ marginLeft: 20, width: 240 }} />}
          onCancel={()=> this.setState({visibleDeleteModal:false})}
          onOk={this.deleteRequest}
          title={`${translationsStore.translate('connectionRequests.vehicleTable.deleteModal.title')}?`}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--primary-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={560}
        >
        </AirModalTitlebar>
        <AirModalTitlebar
          visible={this.state.visibleMessageModalError || this.state.visibleMessageModalSuccess}
          okButton={<AirButton size="large" light label={'Ok'} style={{ marginLeft: 20, width: 240 }} />}
          onOk={()=> this.setState({visibleMessageModalSuccess: false, visibleMessageModalError: false})}
          title={
            this.state.visibleMessageModalError ?
              translationsStore.translate('connectionRequests.vehicleTable.deleteModal.errorMessageDelete')
              :
              translationsStore.translate('connectionRequests.vehicleTable.deleteModal.successMessageDelete')
            }
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--primary-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={560}
        >
        </AirModalTitlebar>
      </div>
    );
  }
}

export default ConnectionRequestTable;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/ConnectionRequestTable/ConnectionRequestTable.js